import type { ActionTree } from 'vuex';
import { getPrefetchData as neoGetPrefetchData } from '@mx/neo';
import type { DeferCashierState, DeferRootState, DefaultPayloadType, HomePagePayLoad } from '../constants';
import { payDeferHomePage, env, monitor, metricPoints, NSFUrl } from '@/common';

interface PrefetchDataType {
  status: string;
  data: HomePageType;
}
export const actions: ActionTree<DeferCashierState, DeferRootState> = {
  // 获取 /paydefer/homepage 数据，取预请求中的数据，失败时用ajax重新请求一次
  getHomePageData(
    { state, getters, commit, dispatch },
    payload: DefaultPayloadType
  ): Promise<HomePageType & { __requestTime: string }> {
    let dispatcherData;
    const requestStartTime = Date.now();
    let enableNSF = 0; // 0 表示不能使用 NSF，1 表示能使用 NSF
    if (env.enableNsf) {
      enableNSF = 1;
      dispatcherData = neoGetPrefetchData<PrefetchDataType>(NSFUrl.Index, {
        ajaxFunc: () => dispatch<HomePagePayLoad>({ type: 'getHomePageDataByAjax' }),
        ajaxDelay: 2500, // 延迟请求时间 单位ms
        timeout: 5000, // 预请求桥超时时间，单位毫秒和降级时间对齐
      });
    } else {
      dispatcherData = dispatch<HomePagePayLoad>({ type: 'getHomePageDataByAjax' });
    }
    monitor.reportMetric(metricPoints.enableNSF, { url: NSFUrl.Index, enableNSF });
    return dispatcherData
      .then((resp) => {
        let NSFIsUse = 0; // 0 表示未使用 NSF 给的请求参数，1 表示使用 NSF 给的请求参数
        // 接口业务失败后，会超时调用上传的ajax请求，直接返回data，没有status
        if (resp.status && resp.data) {
          NSFIsUse = 1;
          // eslint-disable-next-line no-param-reassign
          resp = resp.data;
        }
        monitor.reportMetric(metricPoints.NSFIsUse, { url: NSFUrl.Index, NSFIsUse });
        return {
          ...resp, // 返回接口数据
          __requestTime: Date.now() - requestStartTime,
        };
      })
      .catch((e: Error) => {
        Object.assign(e, { __requestTime: Date.now() - requestStartTime });
        throw e;
      });
  },
  getHomePageDataByAjax({ state, getters, commit, dispatch }) {
    return payDeferHomePage({
      ...env.inpayBasicBusinessParams,
      ...env.coreBusinessParams,
      outer_business_data: env.outerBusinessData, // payDeferHomePage 接口暂未通过解析此字段来获取 scorePlanId，后端后续需调整
      openType: env.performanceOpenType,
      entry: env.entry,
    });
  },
};
